<template>
  <div
    class="quiz-block"
    :style="{ backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff' }"
    style="border-radius: 10px !important;"
  >
    <div class="quiz-image">
      <img
        :class="[quiz_data.is_live ? '' : 'brightness']"
        :src="quiz_data.banner_url"
        alt="quiz"
        class="img-fluid"
      />
    </div>

    <div class="quiz-detail" style="justify-content: center;">
      <div class="play-time-details" style="margin-top: 5px !important;">
        <!-- Timer -->
        <div :class="[active ? 'quiz-end' : '', 'timer']">
          <span
            style="font-size: 11px !important;"
            :style="{ color: !active ? '#479A30' : '#D02828' }"
          >
            {{ active ? "Ends In:- " + time_left : "Starts In:- " + time_left }}
          </span>
        </div>

        <!-- PLAY BUTTON (ONLY THIS PART IS CLICKABLE) -->
        <router-link
          :to="{
            name: 'quiz_details_custom',
            params: { id: quiz_data.id, title: quiz_data.name }
          }"
          style="text-decoration: none;"
        >
          <div
            :style="{
              backgroundColor: isDarkTheme ? buttonBGColor : bgTheme,
              color: isDarkTheme ? headingTextColor : '#ffffff',
              padding: '5px 12px',
              width: '120px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '20px'
              // marginTop: '10px'
            }"
          >
            <div>
              {{
                quiz_data.is_live
                  ? "Play"
                  : button_text && button_text.length > 0
                  ? button_text
                  : "Play"
              }}
            </div>
            <div style="margin-left: 5px;" v-if="active">
              <PlayIcon />
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { asset } from "@/utils/asset";
import moment from "moment";
import { globals } from "@/mixins/globals";
import PlayIcon from "./play-icon.vue";
export default {
  name: "quiz-list-card",
  mixins: [globals],
  props: {
    quiz_data: Object
  },
  components: {
    PlayIcon
  },
  data() {
    return {
      time_left: "",
      active: false,
      dateStr: this.active ? this.quiz_data.ends_at : this.quiz_data.starts_at,
      quiz: this.quiz_data,
      button_text: this.quiz_data.button_text
    };
  },
  methods: {
    formatISODateString(dateStr) {
      var date = new Date(dateStr);
      var month = date.toLocaleString("default", { month: "short" });
      var year = date.getFullYear();
      var hour = date.getHours();
      var min = date.getMinutes();
      var sec = date.getSeconds();
      var dt = date.getDate();

      if (dt < 10) {
        dt = "0" + dt;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (min < 10) {
        min = "0" + min;
      }
      if (sec < 10) {
        sec = "0" + sec;
      }

      // return `${dt} ${month} ${year} ${hour}:${min}:${sec}`;
      return `${hour}h:${min}m:${sec}s`;
    },
    getImgUrl(pic) {
      return asset(pic);
    },
    async showTime(data) {
      let dateStr = "";
      let timeleft = "";
      if (data.is_live || this.active) {
        dateStr = data.ends_at;
      } else {
        dateStr = data.starts_at;
      }
      var d = new Date();
      var d2 = new Date(dateStr);
      var milSec = d2 - d;
      while (milSec > 0) {
        var d3 = new Date(milSec);
        let nrDays = Math.floor(d3 / 1000 / 60 / 60 / 24);
        let nrHours = Math.floor(d3 / 1000 / 60 / 60) % 24;
        let nrMin = Math.floor(d3 / 1000 / 60) % 60;
        let nrSec = Math.floor(d3 / 1000) % 60;

        nrHours = nrHours < 10 ? "0" + nrHours : nrHours;
        nrMin = nrMin < 10 ? "0" + nrMin : nrMin;
        nrSec = nrSec < 10 ? "0" + nrSec : nrSec;
        if (nrDays !== 0) {
          nrDays = nrDays < 10 ? "0" + nrDays + "d:" : nrDays + "d:";
        } else {
          nrDays = "";
        }
        timeleft = `${nrDays}${nrHours}h:${nrMin}m:${nrSec}s`;
        timeleft.replace("-", "");
        milSec -= 1000;
        this.time_left = timeleft;
        await this.sleep(1000);
      }
      if (new Date(data.ends_at) < new Date()) {
        // alert('hi')
        this.$emit("quizend");
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  },
  created() {
    this.button_text = this.quiz_data.button_text;
    this.showTime(this.quiz);
    this.active = Date(this.quiz) > Date();
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    buttonBGColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.buttonBGColor
      ) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    time: () => {
      return this.time_left;
    }
  },
  mounted: function() {
    setInterval(() => {
      //this.date = moment(this.date.subtract(1, 'seconds'))
    }, 1000);
    this.interval = setInterval(
      () => (this.active = new Date(this.quiz.starts_at) < new Date())
    );
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  watch: {
    active(val) {
      if (val) {
        this.quiz_data.is_live = true;
        this.showTime(this.quiz);
      }
    }
  }
};
</script>
<style scoped>
@import "../assets/quiz-styles/quiz-styles.css";

.brightness {
  filter: brightness(0.75);
  opacity: 0.65;
}
.quiz-play {
  display: flex;
  justify-content: center;
  padding: 0.25rem;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}
.h3 {
  color: #736c6c;
  font-size: 20px;
  margin-block-start: 0 !important;
  margin-block-end: 0 !important;
}
.total-prize {
  margin-top: 5px;
  color: #736c6c;
  font-size: 13px;
  font-weight: lighter;
}

.play-time-details {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  /* height: 3rem; */
}
</style>
